import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import NewFeedbackForm from "./NewFeedbackForm";

type Props = {
  closeModalOffCanvas: () => void;
  showModalOffcanvas: boolean;
  onSubmit: (data: any) => void;
  isLoading?: boolean;
};

function NewFeedbackModal({
  closeModalOffCanvas,
  showModalOffcanvas,
  onSubmit,
}: Props) {
  return (
    <MolhamModalOffcanvas
      onHide={closeModalOffCanvas}
      show={showModalOffcanvas}
      header={{ label: "send_feedback" }}
      swipeToClose={false}
      fullscreen
    >
      <NewFeedbackForm
        close={closeModalOffCanvas}
        onSubmit={onSubmit}
        textLength={999}
      />
    </MolhamModalOffcanvas>
  );
}

export default NewFeedbackModal;
